export const UserAccount = {
  Logout: 'Odhlásiť sa',
  PasswordChange: 'Zmena hesla',
  UserAccount: 'Používateľský účet',
};
